import { useEffect, useState } from 'react'
import { useDebounceFnV2, type DebounceOptions } from './useDebounceFnV2'

export function useDebounceValueV2<T>(value: T, wait?: number, options?: DebounceOptions) {
  const [debouncedValue, setDebouncedValue] = useState(value)
  const updateDebouncedValue = useDebounceFnV2(setDebouncedValue, wait, options)

  useEffect(() => {
    updateDebouncedValue(value)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])

  return debouncedValue
}
